import { providerRegistry } from "./registry";
import { salesforgeProvider } from "./salesforge";
import { instantlyProvider } from "./instantly";
import { emailBisonProvider } from "./emailbison";
import { smartleadProvider } from "./smartlead";

/**
 * Initialize the provider registry with all available providers
 */
export function initializeProviders(): void {
  providerRegistry.register(salesforgeProvider);
  providerRegistry.register(instantlyProvider);
  providerRegistry.register(emailBisonProvider);
  providerRegistry.register(smartleadProvider);
}

// Initialize providers when this module is imported
initializeProviders();
